<style lang="less" scoped>
  .query-title-div {
    width: 110px !important;
  }
  .lang-width {
    width: 450px !important;
  }
  .margin-tb {
    height: 32px;
    margin-top: 4px;
  }
  .margin-tb-5{
    margin:5px 0;
  }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">{{mainTitle}}</div>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="listDetailFun()">查 看</button>
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="getListData(pagination, true,isNormal)">
          搜 索
        </button>
        <button class="common-bg-button"
          @click="() => {
              showMultiQuerys = !showMultiQuerys;
            }"
          >高级筛选</button>
      </div>
            <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
                <p class="margin-tb-5 font-14">订单编号</p>
                <el-input
                  v-model="queryInfo.orderNo"
                  size="small"
                  placeholder="请输入订单编号"
                ></el-input>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
              <p class="margin-tb-5 font-14">充电桩IMEI编号</p>
                <el-input
                  v-model="queryInfo.pileCode"
                  size="small"
                  placeholder="请输入充电桩IMEI编号"
                ></el-input>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
              <p class="margin-tb-5 font-14">用户手机号</p>
                <el-input
                  v-model="queryInfo.custPhone"
                  size="small"
                  placeholder="请输入用户手机号"
                ></el-input>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
              <p class="margin-tb-5 font-14">订单状态</p>
              <el-select
                v-model="queryInfo.payStatus"
                size="small"
                filterable
                class="full-width"
                clearable
                placeholder="请选择"
              >
                <el-option label="待支付" value="01"></el-option>
                <el-option label="支付成功" value="02"></el-option>
                <el-option label="支付失败" value="03"></el-option>
                <el-option label="已完成" value="05"></el-option>
              </el-select>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
              <p class="margin-tb-5 font-14">启动方式</p>              
              <el-select
                v-model="queryInfo.startWayName"
                size="small"
                filterable
                class="full-width"
                clearable
                placeholder="请选择"
              >
                <el-option label="刷卡启动" value="刷卡启动"></el-option>
                <el-option label="APP预约" value="APP预约"></el-option>
                <el-option label="APP启动" value="APP启动"></el-option>
                <el-option label="即插即充" value="即插即充"></el-option>
                <el-option label="无感充电" value="无感充电"></el-option>
                <el-option label="私桩共享扫码" value="私桩共享扫码"></el-option>
              </el-select>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
              <p class="margin-tb-5 font-14">结束方式</p>              
              <el-select
                v-model="queryInfo.endWayName"
                size="small"
                filterable
                class="full-width"
                clearable
                placeholder="请选择"
              >
                <el-option label="拔枪" value="拔枪"></el-option>
                <el-option label="车主动断开" value="车主动断开"></el-option>
                <el-option label="指令" value="指令"></el-option>
                <el-option label="充满" value="充满"></el-option>
                <el-option label="刷卡" value="刷卡"></el-option>
                <el-option label="桩故障" value="桩故障"></el-option>
              </el-select>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6">
              <p class="margin-tb-5 font-14">充电时间</p>
              <div class="flex-r">
              <el-date-picker
                  class="full-width"
                  size="small"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  v-model="chargeTime"
                  @change="pickdate(chargeTime)"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections=" (sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData(pagination, false,isNormal)"></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      mainTitle:'正常充电订单',
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      value1: true, //未使用
      chargeTime:[],
      isNormal:true,
      showMultiQuerys:false,
      typeList:[],
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          // {
          //   id: 'report',
          //   label: '报表',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.id)
          //     this.$store.commit('setPileNo', row.pileNo)
          //     // this.$router.push({
          //     // 	name: pageConfig.reportDetailRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'repair',
          //   label: '维修',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.pileCode)
          //     // this.$router.push({
          //     // 	name: pageConfig.repairListDetail
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.repairListDetail })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },

          // {
          //   id: 'charge',
          //   label: '充电记录',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     debugger
          //     this.$store.commit('setEditId', row.pileCode)
          //     // this.$router.push({ name: pageConfig.chargeDetailRouter });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.chargeDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'fault',
          //   label: '故障记录编辑',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.id)
          //     // this.$router.push({ name: pageConfig.faultDetail });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.faultDetail }).href,
          //       '_blank'
          //     )
          //   }
          // },
          // {
          //   id: 'relation',
          //   label: '关联账号',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileCode)
          //     window.open(
          //             this.$router.resolve({ name: pageConfig.relationNum }).href,
          //             '_blank'
          //     )
          //   }
          // }
        ],
      }, // 列操作按钮
      searchTime: [], //系统创建时间
      timeOptionRange:'',
      pickerOptions: {
        onPick: time => {
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: time => {
          const timeOptionRange = this.timeOptionRange;
          const secondNum = 60 * 60 * 24 * 1 * 1000;
          if (timeOptionRange) {
            return (time.getTime() > timeOptionRange.getTime() + secondNum ||     time.getTime() <
            timeOptionRange.getTime() - secondNum);
          }
          return false;
        }
      }
    }
  },
  methods: {
      //查找站点名称 获取数据
    init() {
      console.log(this.$route.name);
      let name = this.$route.name;
      if(name == 'unusualList'){
          this.mainTitle = '异常充电订单'
          this.pageConfig.listBreadCrumb[2].name = '异常订单'
          this.isNormal = false
        }else if(name == 'normalList'){
          this.mainTitle = '正常充电订单'
          this.pageConfig.listBreadCrumb[2].name = '正常订单'
          this.isNormal = true
        }
        console.log(this.isNormal);
      this.getListData(this.pagination, true,this.isNormal)
    },
    // 获取表格数据
    getListData(pagination, reload = false,isNormal=true) {
      let _ = this
      _.$U.showLoading(_)
      if(_.$U.isEmpty(_.chargeTime)){
        _.$U.hideLoading(_)
        return _.$U.error('请先选择充电时间!');
      }
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.orderProperty = '01'
      if(!isNormal){
        _.queryInfo.orderProperty = "02"
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.isShared = 'N';
      _.$H.post(_, _.$A.privatePile.pileOrder, _.queryInfo).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    pickdate(time){
        console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.beginTime = time ? time[0]: ''
      _.queryInfo.endTime = time ? time[1]: ''
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
          this.$U.error('请选择需要操作的对象');
          return false; 
      }
      if (selections.length > 1) {
          this.$U.error('只能选择一个操作的对象');
          return false;
      }
      return true;
    },
    //页面查看方法
    listDetailFun() {
      let _ = this
      if(_.checkSelectOne(_.selections)){
        // this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
        // this.$store.commit('setEditId', _.selections[0].pileCode);
        localStorage.removeItem('detail')
        localStorage.setItem('detail',JSON.stringify(this.selections[0]))
        localStorage.removeItem('isNormal')
        localStorage.setItem('isNormal',_.isNormal)
        let url = this.isNormal? "pileDetailTab":'pileUnusualDetail';
        console.log(url,this.isNormal);
        let routeUrl =  this.$router.resolve({
          name: url,
          
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0]
        this.queryInfo.dtTo = val[1]
      } else {
        delete this.queryInfo.dtFrom
        delete this.queryInfo.dtTo
      }
    },
    //重置
    reset() {
      this.queryInfo = {}
      this.chargeTime = []
      this.getListData(this.pagination,true,this.isNormal)
    },
  },
  mounted() {
    this.init()
  },
  watch:{
    $route(newVal,oldVal){
        console.log('------newVal',newVal,this.isNormal);
      if(newVal.name == 'unusualList'){
          this.mainTitle = '异常充电订单'
          this.pageConfig.listBreadCrumb[2].name = '异常订单'
          this.isNormal = false
        }else if(newVal.name == 'normalList'){
          this.mainTitle = '正常充电订单'
          this.pageConfig.listBreadCrumb[2].name = '正常订单'
          this.isNormal = true
        }
        this.getListData(this.pagination,true,this.isNormal)
    }
  }
}
</script>
